'use strict'
;(function(){
	
    angular.module('inc-basic', []);
    
})();